import React from 'react';
import { Outlet } from "react-router-dom";
import {Header} from './components/CreduMoney/Header';
import Footer from './components/CreduMoney/Footer';
import './css/Common.css'



function Layout() {
  return (
    <div className="wrapper">
    <div id="snackbar"></div>
    <header className="">
      {/* <TopContactBar /> */}
      {/* <Header /> */}
    </header>
    <main className="">
     
    <Outlet />  
    </main>
    <div className="float_content">
 
</div>

    {/* <footer className="">
      <Footer />
    </footer> */}
  </div>
  )
}

export default Layout;